module.exports = __webpack_public_path__ + "static/media/Final1.c9aeb660.jpg";